import { useCallback, useEffect } from 'react'

import { NodeViewWrapper, NodeViewContent, NodeViewProps } from '@tiptap/react'

import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import {
  highlightJsLanguages,
  importHighlightJsLanguage,
} from '../../../common/lib/lowlight.js'
import { T } from '../../../i18n/components/T.js'

export const CodeBlockComponent = ({
  node: { attrs },
  updateAttributes,
}: NodeViewProps) => {
  const { language: defaultLanguage } = attrs
  const loadLanguage = useCallback(
    async (language: string) => {
      await importHighlightJsLanguage(language)
      // force apply new highlight
      updateAttributes(attrs)
    },
    [updateAttributes, attrs],
  )

  useEffect(() => {
    loadLanguage(defaultLanguage)
  }, [defaultLanguage, loadLanguage])

  return (
    <NodeViewWrapper className="code-block relative">
      <Dropdown
        className="start-auto end-2 top-2 absolute"
        placement="bottom-end"
      >
        <Dropdown.Button className="code-language-selector opacity-0 group-hover:opacity-100 transition-opacity">
          {defaultLanguage || 'auto'}
        </Dropdown.Button>
        <Dropdown.Items className="h-80">
          <Dropdown.Item onClick={() => updateAttributes({ language: null })}>
            <T id="Composer.CodeBlock.Auto" defaultMessage="auto" />
          </Dropdown.Item>
          {highlightJsLanguages.map(language => (
            <Dropdown.Item
              key={language}
              onClick={() => updateAttributes({ language })}
            >
              {language}
            </Dropdown.Item>
          ))}
        </Dropdown.Items>
      </Dropdown>
      <pre>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  )
}
